import type { SystemCanvasModuleResponse } from '../../../Library/CustomModule/Library/add-edit.types';
import type { CMTab } from '../../../Library/CustomModule/Library/add-edit.types';
import type from './SystemCanvasModule.type';
import type { SystemCanvasModuleActionType } from './SystemCanvasModule.type';

export interface SystemCanvasModuleState {
  devOrderModuleDataWithSource: SystemCanvasModuleResponse | null;
  devOrderModuleTabDetails: Record<string, Record<string, CMTab>>;
}

interface SystemCanvasModuleAction {
  type: SystemCanvasModuleActionType;
  payload?: unknown;
}

const initialState: SystemCanvasModuleState = {
  devOrderModuleDataWithSource: null,
  devOrderModuleTabDetails: {},
};

const SystemCanvasModuleReducer = (
  state: SystemCanvasModuleState = initialState,
  action: SystemCanvasModuleAction,
): SystemCanvasModuleState => {
  switch (action.type) {
    case type.GET_DEV_ORDER_MODULE_DATA_WITH_SOURCE:
      return {
        ...state,
        devOrderModuleDataWithSource: (action.payload as SystemCanvasModuleResponse) || null,
      };
    case type.GET_DEV_ORDER_MODULE_TAB_DETAILS: {
      const payload = action.payload as { moduleId: string; tabId: string; tab: CMTab };
      return {
        ...state,
        devOrderModuleTabDetails: {
          ...state.devOrderModuleTabDetails,
          [payload?.moduleId]: {
            ...state.devOrderModuleTabDetails[payload?.moduleId],
            [payload?.tabId]: payload?.tab,
          },
        },
      };
    }
    case type.UPDATE_DEV_ORDER_MODULE:
      return {
        ...state,
        devOrderModuleDataWithSource: (action.payload as SystemCanvasModuleResponse) || null,
      };
    case type.CLEAR_DEV_ORDER_MODULE_DATA:
      return {
        ...state,
        devOrderModuleDataWithSource: null,
        devOrderModuleTabDetails: {},
      };
    default:
      return state;
  }
};

export default SystemCanvasModuleReducer;
